module.exports = __webpack_public_path__ + "static/media/21-6.9270f09d.mp3";